import { FhirInstance } from '../config/FhirClient';
import { IBundle } from '../modules/unsw-fhir/Bundle';
import {
  IOperationOutcome,
  isOperationOutcome,
} from '../modules/unsw-fhir/OperationOutcome';
import {
  IOrganization,
  isOrganization,
} from '../modules/unsw-fhir/Organization';

export const getOrganizations = async () => {
  try {
    const response = await FhirInstance.get<IBundle | IOperationOutcome>(
      '/Organization',
    );
    const { data } = response;
    if (isOperationOutcome(data) || !data.entry) {
      return [];
    }
    return data.entry
      .filter(entry => {
        return !!entry.resource && isOrganization(entry.resource);
      })
      .map((entry): IOrganization => entry.resource as IOrganization);
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getOrganizationById = async (id: string) => {
  try {
    const response = await FhirInstance.get<IOrganization | IOperationOutcome>(
      `/Organization/${id}`,
    );
    const { data } = response;
    if (isOperationOutcome(data)) {
      return undefined;
    }
    return data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
